export default __webpack_public_path__ + "static/media/coinbase.d4276809.svg";